<template>
  <div class="globe" id="globe">
    <!-- 详细查询 -->
    <el-dialog :visible.sync="detailVisible" width="53vw">
      <template v-slot:title>
        <div class="dt-top">完善信息</div>
      </template>
      <el-collapse v-model="collapseChoose" class="dt-collapse">
        <el-collapse-item name="1">
          <template v-slot:title>
            <div class="dt-title-icon"></div>
            <p class="dt-title">企业基本信息</p>
          </template>
          <el-form :model="gsData" class="jjzbform jbxx" label-width="150px">
            <el-row>
              <el-col :span="12">
                <el-form-item label="企业名称">
                  <el-input v-model="gsData.name" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="注册地">
                  <el-select
                    v-model="gsData.zcdz"
                    clearable
                    placeholder="请选择注册地址"
                    :style="{ width: '100%' }"
                  >
                    <el-option label="信阳市" value="0"></el-option>
                    <el-option label="省内其他地市" value="1"></el-option>
                    <el-option label="省外" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label-width="150px" label="纳税地" prop="xzqh1">
                  <el-select
                    v-model="gsData.qynsd"
                    clearable
                    placeholder="请选择纳税地"
                    :style="{ width: '100%' }"
                  >
                    <el-option label="信阳市" value="0"></el-option>
                    <el-option label="省内其他地市" value="1"></el-option>
                    <el-option label="省外" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 待修改 -->
              <el-col :span="12">
                <el-form-item label="所属行业">
                  <FormSelect
                    v-model="gsData.gwjjfl"
                    size="small"
                    multiple
                    :options="getDictList('sys_category')"
                    valueKey="key"
                    style="width: 100%"
                  ></FormSelect>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="产业类别">
                  <FormSelect
                    style="width: 100%"
                    v-model="gsData.cylx"
                    multiple
                    size="small"
                    :options="getDictList('sys_enter_type')"
                    valueKey="key"
                  ></FormSelect>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="企业注册类型">
                  <FormSelect
                    style="width: 100%"
                    v-model="gsData.enterpriseRegisterType"
                    size="small"
                    :options="getDictList('enterprise_register_type')"
                    valueKey="key"
                  ></FormSelect>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="企业资质">
                  <FormSelect
                    style="width: 100%"
                    v-model="gsData.enterpriseQualification"
                    multiple
                    size="small"
                    :options="getDictList('enterprise_qualification')"
                    valueKey="key"
                  ></FormSelect>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="统计关系所在地">
                  <el-select
                    v-model="gsData.tjgxszd"
                    placeholder="请选择统计关系所在地"
                  >
                    <el-option label="信阳市" value="0"></el-option>
                    <el-option label="省内其他地市" value="1"></el-option>
                    <el-option label="省外" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-collapse-item>
        <el-collapse-item name="3">
          <template v-slot:title>
            <div class="dt-title-icon"></div>
            <p class="dt-title">企业经营信息</p>
          </template>
          <el-row :gutter="0">
            <el-tabs v-model="activeName">
              <el-tab-pane
                v-for="(jjzb, index) in gsData.jjzbList"
                :key="index"
                :label="nowYear - Number(index) - 1 + ''"
                :name="nowYear - Number(index) - 1 + ''"
              >
                <el-form
                  :ref="'elForm' + index"
                  :model="jjzb"
                  size="small"
                  label-width="144px"
                  class="jjzbform"
                >
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="总资产" prop="zzc">
                        <el-input
                          type="number"
                          v-model="jjzb.zzc"
                          placeholder="请输入总资产"
                          :style="{ width: '100%' }"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="净利润" prop="jlr">
                        <el-input
                          type="number"
                          v-model="jjzb.jlr"
                          placeholder="请输入净利润"
                          :style="{ width: '100%' }"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="营业收入(万元)" prop="yysr">
                        <el-input
                          type="number"
                          v-model="jjzb.yysr"
                          placeholder="请输入营业收入(万元)"
                          :style="{ width: '100%' }"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="主营业务收入(万元)" prop="zyywsr">
                        <el-input
                          type="number"
                          v-model="jjzb.zyywsr"
                          placeholder="请输入主营业务收入(万元)"
                          :style="{ width: '100%' }"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="资产投入(万元)" prop="zctr">
                        <el-input
                          type="number"
                          v-model="jjzb.zctr"
                          placeholder="请输入资产投入(万元)"
                          :style="{ width: '100%' }"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="负债总额(万元)" prop="fzze">
                        <el-input
                          type="number"
                          v-model="jjzb.fzze"
                          placeholder="请输入负债总额(万元)"
                          :style="{ width: '100%' }"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="税收总额(万元)" prop="nsze">
                        <el-input
                          type="number"
                          v-model="jjzb.nsze"
                          placeholder="请输入税收总额(万元)"
                          :style="{ width: '100%' }"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="研发投入(万元)" prop="yftl">
                        <el-input
                          type="number"
                          v-model="jjzb.yftl"
                          placeholder="请输入研发投入"
                          :style="{ width: '100%' }"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </el-tab-pane>
            </el-tabs>
          </el-row>
        </el-collapse-item>
        <el-collapse-item name="4">
          <template v-slot:title>
            <div class="dt-title-icon"></div>
            <p class="dt-title">知识产权</p>
          </template>
          <el-row :gutter="0">
            <el-form
              :model="gsData.zscq"
              size="small"
              label-width="144px"
              class="jjzbform"
              ref="zscqForm"
            >
              <el-row>
                <el-col :span="12">
                  <el-form-item label="知识产权总数" prop="zscqzs">
                    <el-input
                      type="number"
                      v-model="gsData.zscq.zscqzs"
                      placeholder="请输入总资产"
                      :style="{ width: '100%' }"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="专利总数" prop="zlzs">
                    <el-input
                      type="number"
                      v-model="gsData.zscq.zlzs"
                      placeholder="请输入专利总数"
                      :style="{ width: '100%' }"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="注册商标总数" prop="zcsbzs">
                    <el-input
                      type="number"
                      v-model="gsData.zscq.zcsbzs"
                      placeholder="请输入注册商标总数"
                      :style="{ width: '100%' }"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="软件著作总数" prop="rjzzzs">
                    <el-input
                      type="number"
                      v-model="gsData.zscq.rjzzzs"
                      placeholder="请输入软件著作总数"
                      :style="{ width: '100%' }"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-row>
        </el-collapse-item>
        <el-collapse-item name="5">
          <template v-slot:title>
            <div class="dt-title-icon"></div>
            <p class="dt-title">人才信息</p>
          </template>
          <el-row :gutter="0">
            <el-form
              :model="gsData.rcxx"
              size="small"
              label-width="144px"
              class="jjzbform"
              ref="rcxxForm"
            >
              <el-row>
                <el-col :span="12">
                  <el-form-item label="企业总人数" prop="qyzrs">
                    <el-input
                      type="number"
                      v-model="gsData.rcxx.qyzrs"
                      placeholder="请输入企业总人数"
                      :style="{ width: '100%' }"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="科技人数" prop="kjrs">
                    <el-input
                      type="number"
                      v-model="gsData.rcxx.kjrs"
                      placeholder="请输入科技人数"
                      :style="{ width: '100%' }"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="高级职称总人数" prop="gjzcrs">
                    <el-input
                      type="number"
                      v-model="gsData.rcxx.gjzcrs"
                      placeholder="请输入高级职称总人数"
                      :style="{ width: '100%' }"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="中级职称总人数" prop="zjzcrs">
                    <el-input
                      type="number"
                      v-model="gsData.rcxx.zjzcrs"
                      placeholder="请输入中级职称总人数"
                      :style="{ width: '100%' }"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-row>
        </el-collapse-item>
      </el-collapse>
      <el-divider></el-divider>
      <div class="dt-div-btn">
        <el-button class="dt-confirm" @click="saveCompanyData()"
          >获取智能推荐报告</el-button
        >
      </div>
    </el-dialog>
    <div class="sub_wrapper">
      <policy-nav
        :chooseQy="chooseQy"
        :perfectInfo="perfectInfo"
        :report="report"
      ></policy-nav>
      <div class="main_wrap w_1200">
        <div class="company_box">
          <div class="comp_cont">
            <!-- <div class="tit_row"><span class="slh">企业码河南刚辉纺织科技有公司</span><i class="state">续存</i></div> -->
            <div class="tit_row">
              <span class="slh">{{ gsData.name }}</span
              ><i class="state">续存</i>
            </div>
            <div class="ms_row">
              <span
                >产业类别:
                <span v-if="userBaseInfo">
                  {{ cpu_noText(getDictLabels("sys_enter_type", gsData.cylx)) }}
                </span>
                <span v-else>
                  {{
                    cpu_noText(
                      getDictLabels(
                        "sys_enter_type",
                        formData.cylx.length > 0 ? formData.cylx : gsData.cylx
                      )
                    )
                  }}
                </span>
              </span>
              <span
                >注册类型:
                <span v-if="userBaseInfo">
                  {{
                    cpu_noText(
                      getDictLabel(
                        "enterprise_register_type",
                        gsData.enterpriseRegisterType
                      )
                    )
                  }}
                </span>
                <span v-else>
                  {{
                    cpu_noText(
                      getDictLabel(
                        "enterprise_register_type",
                        formData.enterpriseRegisterType
                          ? formData.enterpriseRegisterType
                          : gsData.enterpriseRegisterType
                      )
                    )
                  }}
                </span>
              </span>
              <span
                >所属行业:
                <span v-if="userBaseInfo">
                  {{ cpu_noText(getDictLabels("sys_category", gsData.gwjjfl)) }}
                </span>
                <span v-else>
                  {{
                    cpu_noText(
                      getDictLabels(
                        "sys_category",
                        formData.gwjjfl.length > 0
                          ? formData.gwjjfl
                          : gsData.gwjjfl
                      )
                    )
                  }}
                </span>
              </span>
              <span
                >企业资质:
                <span v-if="userBaseInfo">
                  {{
                    cpu_noText(
                      getDictLabels(
                        "enterprise_qualification",
                        gsData.enterpriseQualification
                      )
                    )
                  }}
                </span>
                <span v-else>
                  {{
                    cpu_noText(
                      getDictLabels(
                        "enterprise_qualification",
                        formData.enterpriseQualification.length > 0
                          ? formData.enterpriseQualification
                          : gsData.enterpriseQualification
                      )
                    )
                  }}
                </span>
              </span>
            </div>
            <a class="base_btn" @click="tonewpage">完善企业信息</a>
          </div>
        </div>

        <ul class="tab_tit tab_tit02">

          <li
            class="item"
            @click="changechoose(1)"
            :class="{ active: choosetype == 1 }"
          >
            智能推荐政策
          </li>
          <li
            class="item"
            @click="changechoose(2)"
            :class="{ active: choosetype == 2 }"
          >
            智能推荐项目
          </li>
          <li
            class="item"
            @click="changechoose(3)"
            :class="{ active: choosetype == 3 }"
          >
            我可兑现的政策
          </li>
        </ul>
        <div v-if="choosetype == 2">
          <div v-if="policyDataList.length == 0" style="text-align: center">
            暂无数据
          </div>
          <ul class="result_list result_list2">
            <li v-for="(item, i) in policyDataList" :key="i">
              <a href="#" class="li_tit slh" :title="item.item.itemName">{{
                item.item.itemName
              }}</a>
              <div class="li_ms">
                <span
                  >扶持方式：{{
                    cpu_noText(getDictLabel("sq_policy_zjlx", item.item.zcfs))
                  }}</span
                >
                <span>项目状态：{{ item.item.xmzt }}</span>
                <span>剩余申报时间：{{ getDay(item.endTime) }}</span>
                <span class="star_box">
                  匹配度：
                  <!--                              <i class="star star_l"></i>-->
                  <!--                              <i class="star star_l"></i>-->
                  <!--                              <i class="star star_l"></i>-->
                  <!--                              <i class="star star_l"></i>-->
                  <!--                              <i class="star"></i>-->
                  <em>{{ Math.round(item.percentage) }}%</em>
                </span>
              </div>
              <div class="li_zj">
                <div class="name">
                  <div
                    v-if="getDictLabel('sq_policy_zjlx', item.zcfs) == '资金'"
                  >
                    最高扶持金额<span style="color: #ffaa00">{{
                      item.money
                    }}</span
                    >万元
                  </div>
                  <div v-else>根据实际情况给予扶持</div>
                </div>
              </div>
              <a class="base_btn li_btn" @click="todetailpage(item)"
                >查看详情</a
              >
            </li>
          </ul>
          <el-pagination
            class="pg-css"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.pagenum"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="pagination.pagesize"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total"
          >
          </el-pagination>
        </div>
        <div v-if="choosetype == 1">
          <div v-if="newpolicyDataList.length == 0" style="text-align: center">
            暂无数据
          </div>
          <ul class="result_list result_list2">
            <li v-for="(item, i) in newpolicyDataList" :key="i">
              <a href="#" class="li_tit slh" :title="item.name">{{
                item.name
              }}</a>
              <div class="li_ms">
                <span
                  >扶持方式：{{
                    cpu_noText(getDictLabel("sq_policy_zjlx", item.zcfs))
                  }}</span
                >
                <span
                  >政策状态：{{
                    cpu_limitTime(item.starttime, item.endtime)
                  }}</span
                >
                <span>剩余实施时间：{{ getDay(item.endtime) }}</span>
                <span class="star_box">
                  匹配度：
                  <!--                              <i class="star star_l"></i>-->
                  <!--                              <i class="star star_l"></i>-->
                  <!--                              <i class="star star_l"></i>-->
                  <!--                              <i class="star star_l"></i>-->
                  <!--                              <i class="star"></i>-->
                  <em>{{ item.score }}%</em>
                </span>
              </div>
              <div class="li_zj">
                <div
                  class="rt-money"
                  v-if="getDictLabel('sq_policy_zjlx', item.zcfs) == '资金'"
                >
                  根据项目实际情况给予扶持
                </div>
                <div class="rt-money" v-else>根据实际情况给予扶持</div>
              </div>
              <a class="base_btn li_btn" @click="todetailpages(item)"
                >查看详情</a
              >
            </li>
          </ul>
          <el-pagination
            class="pg-css"
            @size-change="handleSizeChange2"
            @current-change="handleCurrentChange2"
            :current-page="pagination2.pagenum"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="pagination2.pagesize"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination2.total"
          >
          </el-pagination>
        </div>
        <div v-if="choosetype == 3">
          <el-table style="cursor: pointer;" :data="policyDataList3" :show-header="false">
            <el-table-column>
              <el-row class="re-top" slot-scope="item">

                <el-col :span="20">
                  <div @click="topage(item)" class="re-list-name">
                    {{ item.row.policyName }}
                  </div>
                </el-col>
                <el-col :span="6">
                  <div>
                    <!-- <span class="re-tag">认定奖励</span> -->
                    <span class="re-tag" :title="item.row.deptName">{{
                    item.row.deptName
                  }}</span>
                  </div>
                </el-col>
                <el-col :span="6" style="margin-top: 0.7rem" align="left">

                  有效时间:{{ item.row.startTime }}至{{
                  cpu_limitTime(item.row.endTime)
                  }}
                </el-col>
                <el-col :span="4" style="margin-top: 0.7rem">
                  发布时间:{{ item.row.publictime }}
                </el-col>
                <el-col :span="4" style="margin-top: -0.8rem;margin-left:10rem;" align="right">
                  <el-button
                    class="rt-btn"
                    @click="topage2(item)"
                  >查看详情</el-button
                  >
                </el-col>
              </el-row>
            </el-table-column>
          </el-table>
          <el-pagination
            class="pg-css"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagenum"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="pagesize"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="searchInfo.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import warterMark from "@/utils/waterMark";
import policyNav from "./policyNav";
import { mapGetters } from "vuex";
import {
  getApplyFunding,
  getProLeftTime,
  getProMatching,
  getDeptAll,
  getProTypeAll,
  getFinanceThreeYear,
  getIntellectualProperty,
  getDeptFiveStar,
  getDeptFourStar,
  getDeptThreeStar,
  getcountryProType,
  getProvincialProType,
  getcityProType,
} from "@/mixins/policyCoutReport.js";
const nowYear = Number(new Date().getFullYear());
const NOW = new Date();
import { FormSelect } from "@/components/form/index.js";
export default {
  data() {
    return {
      loading: true,
      chooseQy: "",
      perfectInfo: "",
      report: "report",
      colors: ["#FFAA00", "#FFAA00", "#FFAA00"],
      showDept: "deptAll",
      ksbzzData: {}, //预期可申报资助
      xmppdData: {}, //政策项目匹配度情况
      limitTimeData: {}, //政策项目申报截至剩余时间
      nowYear,
      activeName: nowYear - 1 + "",
      formData: {
        cylx: [],
        enterpriseQualification: [],
        regtype: "",
        gwjjfl: [],
      }, // 查询参数
      gsData: {
        cylx: [], //产业类别
        enterpriseQualification: [], //企业资质
        regtype: "",
        gwjjfl: [], //'国民经济分类'
        curShxydm: "",
        industry: "",
        money: "",
        scale: "",
        tjgxszd: "", //统计关系所在地（区划ID）
        qynsd: "", //企业纳税地
        hymc: "", //'国民行业名称'
        industrytype: "", //产业名称
        qyxz: "", //企业性质（注册类型）',
        qyxzname: "", //'企业性质名称',
        name: "", //企业名称
        zcdz: "", //注册地址
        xzqhdm: "", //行政区划代码（注册地区划）
        xzqh3: "", // 行政区划-区（县）
        zcsj: "", // 注册时间
        enterpriseRegisterType: "", //企业注册类型
        ryName: "", // 荣誉资质名称
        // 知识产权
        zscq: {},
        // 人才信息
        rcxx: {},
        jjzbList: [], // 近三年经济指标
      }, // 公司信息
      policyDataList: [],
      newpolicyDataList: [],
      pagination: {
        pagesize: 10,
        pagenum: 1,
        total: 0,
      },
      pagination2: {
        pagesize: 10,
        pagenum: 1,
        total: 0,
      },
      detailVisible: false,
      newData: {
        yysr: "",
        zyywsr: "",
        xssr: "",
        jlr: "",
        jzc: "",
        zzc: "",
        ckze: "",
        jkze: "",
        fzze: "",
        ml: "",
        yftl: "",
        zdxmtz: "",
        nsze: "",
        qnsze: "",
        nszm: "",
        qysds: "",
        zzs: "",
        zrsds: "",
        qts: "",
        bz: "",
        createTime: "",
        updateTime: "",
        // webEid: '',
        year: "", // 年份
      },

      pagesize: 10,
      pagenum: 1,
      bgActive: "first", // tab展示
      deptActive: "deptAll", // 受理部门分布 查看
      proTypeActive: "allProType", // 项目类别查看 查看
      collapseChoose: ["1", "2", "3"], // 选择
      xmfbqkListALl: [], //echarts受理部门全部分布情况
      alldeptData: [], //受理部门拼装完成后的数据
      xmlbflAll: [], //echarts项目类别全部分布情况
      allproData: [], //项目类别拼装完成后的数据
      choosetype: 1,
      policyDataList3:[],
      searchInfo: {
        keyWord: "",
        zcfs: "",
        policyLevel: "",
        startTime: "",
        deptId: "",
        pageSize: 10000,
        pageNum: 1,
        total: 0,
      }, //搜索内容

      showpolicyList: [],
    };
  },
  components: {
    FormSelect,
    policyNav,
  },
  computed: {
    ...mapGetters({
      userBaseInfo: "getUserInfo",
      getDictList: "dictionary/getDictList",
      getDictLabel: "dictionary/getDictLabel",
      getDictLabels: "dictionary/getDictLabels",
    }),
    cpu_noText() {
      return function (val) {
        return val || "--";
      };
    },
    cpu_limitTime() {
      return function (starttime, endtime) {
        if (
          endtime == undefined ||
          endtime == "undefined" ||
          endtime == "" ||
          endtime == "长期有效" ||
          endtime.slice(0, 4) == "2099"
        ) {
          return "有效";
        }
        let endTime = new Date(endtime);
        let startTime = new Date(starttime);
        let nowTime = new Date();
        let restSec = nowTime.getTime() - startTime.getTime();
        if (restSec < 0) {
          return "未开始";
        }
        let restSec2 = endTime.getTime() - nowTime.getTime();
        if (restSec2 < 0) {
          return "失效";
        } else {
          return "有效";
        }
      };
    },
  },
  watch: {
    formData: {
      handler: function (newVal) {
        return newVal;
      },
      deep: true,
    },
    gsData: {
      handler: function (newVal) {
        return newVal;
      },
      deep: true,
    },
  },
  created() {
    // warterMark.set("漯河政策计算器");
    let sessionData = JSON.parse(sessionStorage.getItem("policySearchData"));
    if (sessionData) {
      this.formData = sessionData;
      if (!this.formData.enterpriseQualification) {
        this.formData.enterpriseQualification = [];
      }
      if (!this.formData.cylx) {
        this.formData.cylx = [];
      }
      if (!this.formData.gwjjfl) {
        this.formData.gwjjfl = [];
      }
    }
    let paramsData = this.formData;
    if (this.formData && !this.userBaseInfo) {
      this.nologinresult(paramsData);
      this.newresult(paramsData);
      this.getCompanydetails(paramsData.curShxydm);
    } else {
      this.getCompanydetails(this.userBaseInfo.tyshxydm);
      this.getpx();
    }
    this.$store.dispatch("dictionary/commonSetDic", {
      types: [
        "sys_enter_type",
        "sys_category",
        "sys_enterprise_registertype",
        "enterprise_qualification",
        "sq_policy_zjlx",
        "enterprise_register_type",
      ],
    });
  },
  mounted() {
    // this.echartest()
  },
  methods: {
    // 获取所有政策
    gettabelList() {
      this.searchInfo.tyshxydm = '';
      this.searchInfo.authorStatus = '';
      this.requesturl = "/dev-api/avoid/apply/selectAvoidApplyList";
        if (this.userBaseInfo) {
          this.searchInfo.tyshxydm = this.userBaseInfo.tyshxydm;
          this.searchInfo.authorStatus = 0;
        } else {
          this.$router.push({ path: "/login2" });
        }
      this.showpolicyList = [];
      this.policyDataList3 = [];
      const loading = this.$loading({
        lock: true,
        text: "加载中，请稍后",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.3)",
        customClass: "loadingin",
      });
      this.$httpApi
        .post(this.requesturl, this.searchInfo)
        .then((r) => {
          console.log('-------------------------',r);
          let arr = r.data.list;
          arr.sort(this.compare("isCheck"));
          // 排序,可申报项目在前，isCheck为0不可申报
          this.showpolicyList = arr;
          this.policyDataList3 = this.showpolicyList.slice(0, 10);
          this.searchInfo.total = r.data.total;

          loading.close();
          this.pagesize = 10;
          this.pagenum = 1;
        })
    },
    // 对象数组按某一元素排序
    compare(property) {
      return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return value2 - value1;
      };
    },
    topage(item) {
      let row = item.row;
      row.content ="";
      window.sessionStorage.setItem("requesturlType", '');  //  置为空

        let data = JSON.stringify(row);
        sessionStorage.setItem("policyDetailData", data);
        window.sessionStorage.setItem("flag", false);
        window.sessionStorage.setItem("status", false);
        let { href } = this.$router.resolve({
          name: "showPolicyDetail",
        });
        window.sessionStorage.setItem("requesturlType", this.requesturlType);  //  用于回退回来跳转到指定的分类下面
        window.open(href, "_blank");

    },
    topage2(item) {
      let row = item.row;
      row.content ="";
      window.sessionStorage.setItem("requesturlType", '');  //  置为空
        // this.dialogVisible = true;
        // let item = row;
        // this.formData['userId'] = this.userInfo.userId;
        // this.formData['enterpriseFr'] = this.userInfo.enterpriseInfo.name;
        // this.formData['phone'] = this.userInfo.enterpriseInfo.phone;
        // this.formData['enterpriseName'] = this.userInfo.enterpriseInfo.enterprise;
        // this.formData['endTime'] = item.startTime + '至' + this.cpu_limitTime(item.endTime);
        // this.formData['policyName'] = item.policyName;
        // this.formData['policyId'] = item.policyId;
        let data = JSON.stringify(row);
        sessionStorage.setItem("policyDetailData", data);
        window.sessionStorage.setItem("flag", false);
        window.sessionStorage.setItem("status", false);
        let { href } = this.$router.resolve({
          name: "showPolicyDetail",
        });
        window.sessionStorage.setItem("requesturlType", this.requesturlType);  //  用于回退回来跳转到指定的分类下面
        window.open(href, "_blank");

    },

    deptStarChange(val) {
      this.showDept == val;
      // let deptdocu=document.getElementById("deptAll")
      //  deptdocu.removeAttribute("_echarts_instance_");
      let deptAll = this.$echarts.init(document.getElementById("deptAll"));
      deptAll.clear();
      switch (val) {
        case "deptFiveStar":
          let deptOption2 = getDeptFiveStar(this.alldeptData);
          deptAll.setOption(deptOption2);
          break;
        case "deptFourStar":
          let deptOption3 = getDeptFourStar(this.alldeptData);
          deptAll.setOption(deptOption3);
          break;
        case "deptThreeStar":
          let deptOption4 = getDeptThreeStar(this.alldeptData);
          deptAll.setOption(deptOption4);
          break;
        case "deptAll":
          let deptOption = getDeptAll(this.alldeptData);
          deptAll.setOption(deptOption);
          break;
        default:
          break;
      }
    },
    proStarChange(val) {
      this.proTypeActive = val;
      let proType = this.$echarts.init(document.getElementById("proType"));
      proType.clear();
      switch (val) {
        case "countryProType":
          let deptOption2 = getcountryProType(this.allproData);
          proType.setOption(deptOption2);
          break;
        case "ProvincialProType":
          let deptOption3 = getProvincialProType(this.allproData);
          proType.setOption(deptOption3);
          break;
        case "cityProType":
          let deptOption4 = getcityProType(this.allproData);
          proType.setOption(deptOption4);
          break;
        case "allProType":
          let deptOption = getProTypeAll(this.allproData);
          proType.setOption(deptOption);
          break;
        default:
          break;
      }
    },
    handleSizeChange(val) {
      let size = val;
      this.pagination.pagesize = val;
      if (this.userBaseInfo) {
        this.getpx(size, this.pagination.pagenum);
      } else {
        this.nologinresult(this.formData);
      }
    },
    handleCurrentChange(val) {
      let num = val;
      this.pagination.pagenum = val;
      if (this.userBaseInfo) {
        this.getpx(this.pagination.pagesize, num);
      } else {
        this.nologinresult(this.formData);
      }
    },
    handleSizeChange2(val) {
      let size = val;
      this.pagination2.pagesize = val;
      if (this.userBaseInfo) {
        this.getpx();
      } else {
        this.newresult(this.formData);
      }
    },
    handleCurrentChange2(val) {
      let num = val;
      this.pagination2.pagenum = val;
      if (this.userBaseInfo) {
        this.getpx();
      } else {
        this.newresult(this.formData);
      }
    },
    async getpx(pagesize, pagenum) {
      let url = "/dev-api/policy/evaluation/rebuild";
      let result = await this.$httpApi.get(url, {
        shxydm: this.userBaseInfo.tyshxydm,
      });
      if (result.code == 200) {
        this.nologinresult(this.gsData);
        this.newresult(this.gsData);
        // this.newresult()
        // this.ksbzzData = result.data.analysisEcharts.ksbzz;
        // this.xmppdData = result.data.analysisEcharts.xmppd;
        // this.limitTimeData = result.data.analysisEcharts.limitTime;
        // this.xmfbqkListALl = result.data.analysisEcharts.analysisDept;
        // this.xmlbflAll = result.data.analysisEcharts.zcjb;
        // this.echartest();
      }
    },
    nologinresult(param) {
      let url = "/dev-api/policy/evaluation/policymatching";
      let params = param;
      params["pageSize"] = this.pagination.pagesize;
      params["pageNum"] = this.pagination.pagenum;
      this.$httpApi
        .post(url, params)
        .then((res) => {
          const _this = this;
          setTimeout(function () {
            _this.loading = false;
          }, 1000);
          if (res.code == 200) {
            this.policyDataList = res.data.list.rows;
            for (let i in this.policyDataList) {
              let percentage = this.policyDataList[i].percentage;
              this.policyDataList[i].percentage = percentage.toFixed(2);
            }

            this.pagination.total = res.data.list.total;
            // this.ksbzzData = res.analysisEcharts.ksbzz;
            // this.xmppdData = res.analysisEcharts.xmppd;
            // this.limitTimeData = res.analysisEcharts.limitTime;
            // this.xmfbqkListALl = res.analysisEcharts.analysisDept;
            // this.xmlbflAll = res.analysisEcharts.zcjb;
            // this.echartest();
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((e) => {});
    },
    tonewpage() {
      if (this.userBaseInfo) {
        this.detailVisible = true;
      } else {
        this.$router.push({ name: "policy", params: { reopen: true } });
      }
    },
    getEnterpriseList(shxydm) {
      let url = "/dev-api/enterprise/baseInfo/list";
      let params = {
        pageSize: 10, // 页大小
        pageNum: 1, // 页码
        shxydm: shxydm,
      };
      this.$httpApi
        .get(url, params)
        .then((res) => {
          console.log("企业用户基本信息列表>>>", res);
          if (res.code === 200 && res.rows.length > 0) {
            let resList = JSON.parse(JSON.stringify(res.rows));
            const _that = this;
            let stringList = ["rzqd", "qyyd"];
            let target = resList[0];
            for (const [k, v] of Object.entries(target)) {
              if (v === "null") {
                target[k] = "";
              }
            }
            for (const i in target) {
              for (const item of stringList) {
                if (i.indexOf(item) !== -1) {
                  target[i] = _that.transformSA(target[i]);
                  // console.log(">>>>", i)
                }
              }
            }

            //市级区划回显
            if (Number(target.xzqh1) == "411100000000") {
              target.xzqh1 = [411100000000];
            }
            //区级区划回显
            else if (
              Number(target.xzqh1) == Number(target.xzqh2) &&
              Number(target.xzqh2) == Number(target.xzqh3)
            ) {
              target.xzqh1 = [411100000000, Number(target.xzqh1)];
            }
            //街道级区划回显
            else if (
              Number(target.xzqh1) != Number(target.xzqh2) &&
              Number(target.xzqh2) == Number(target.xzqh3)
            ) {
              target.xzqh1 = [
                411100000000,
                Number(target.xzqh1),
                Number(target.xzqh2),
              ];
            }
            //居委会级区划回显
            else {
              target.xzqh1 = [
                411100000000,
                Number(target.xzqh1),
                Number(target.xzqh2),
                Number(target.xzqh3),
              ];
            }
            console.log("列表清洗后的数据>>>", target);
            _that.$store.commit("updateAccountId", target.id);
            _that.gsData = target;
          }
        })
        .catch((err) => {});
    },
    getCompanydetails(shxydm) {
      let url = "/dev-api/enterprise/baseInfo/getEnterpriseByShxydm";
      this.$httpApi
        .get(url, { shxydm: shxydm })
        .then((res) => {
          if (res.code === 200) {
            const _that = this;
            // let stringList = ["rzqd", "qyyd"];
            let target = JSON.parse(JSON.stringify(res.data));
            for (const [k, v] of Object.entries(target)) {
              if (v === "null") {
                target[k] = "";
              }
            }
            // 将字符串转成数字
            let numberList = [
              "zscqzs",
              "zlzs",
              "zcsbzs",
              "rjzzzs",
              "qyzrs",
              "kjrs",
              "gjzcrs",
              "zjzcrs",
              "cjzcrs",
              "gcjsryrs",
            ];
            Object.keys(target.zscq).forEach((key) => {
              if (numberList.indexOf(key) !== -1) {
                target.zscq[key] = Number(target.zscq[key]);
              }
            });
            Object.keys(target.rcxx).forEach((key) => {
              if (numberList.indexOf(key) !== -1) {
                target.rcxx[key] = Number(target.rcxx[key]);
              }
            });
            console.log("列表清洗后的数据>>>", target);
            this.$store.commit("updateAccountId", target.id);
            _that.gsData = Object.assign(_that.gsData, target);
            const newData = this.newData;
            let jjzbCreate = [newData, newData, newData];
            let case1 = nowYear - 1 + "";
            let case2 = nowYear - 2 + "";
            let case3 = nowYear - 3 + "";
            jjzbCreate = JSON.parse(JSON.stringify(jjzbCreate));
            jjzbCreate[0].year = case1;
            jjzbCreate[1].year = case2;
            jjzbCreate[2].year = case3;
            if (target.jjzbList.length == 0) {
              this.gsData.jjzbList = jjzbCreate;
            } else {
              for (const item of target.jjzbList) {
                switch (item.year) {
                  case case1:
                    jjzbCreate[0] = item;
                    break;
                  case case2:
                    jjzbCreate[1] = item;
                    break;
                  case case3:
                    jjzbCreate[2] = item;
                    break;
                }
                this.gsData.jjzbList = jjzbCreate;
              }
            }
          }
        })
        .catch((e) => {});
    },
    transformSA(el) {
      let target;
      if (Array.isArray(el)) {
        // 如果是数组
        target = el.toString();
      } else if (typeof el === "string") {
        //  如果是字符串
        target = el.split(",");
      } else {
        console.log("非法传参");
        target = [];
      }
      // console.log("最后输出值>>>", target)
      return target;
    },
    getDay(time) {
      if (time) {
        if (time.slice(0, 4) == "2099" || time == "长期有效") {
          return "长期有效";
        }
        let setTime = new Date(time);
        let nowTime = new Date();
        let restSec = setTime.getTime() - nowTime.getTime();
        if (restSec < 0) {
          return "已过期";
        }
        let day = Math.ceil(restSec / (60 * 60 * 24 * 1000)); //改为向上取整 0.5天算一天
        return "剩余" + day + "天";
      } else {
        return "长期有效";
      }
    },
    todetailpage(item) {
      let data = item.item;
      this.$store.commit("updateCurrentGuideId", data.sxid);
      const { href } = this.$router.resolve({
        path: "/guideSuqiu",
        query: {
          id: data.sxid,
          name: data.itemName,
        },
      });
      window.open(href, "_blank");
    },
    saveCompanyData() {
      let url = "/dev-api/enterprise/baseInfo/perfectEnterpriseInfo";
      let params = JSON.parse(JSON.stringify(this.gsData));
      if (params.gwjjfl.length > 1) {
        params.gwjjfl = params.gwjjfl.join(",");
      } else {
        params.gwjjfl = params.gwjjfl.toString();
      }
      if (params.cylx.length > 1) {
        params.cylx = params.cylx.join(",");
      } else {
        params.cylx = params.cylx.toString();
      }
      if (params.enterpriseQualification.length > 1) {
        params.enterpriseQualification =
          params.enterpriseQualification.join(",");
      } else {
        params.enterpriseQualification =
          params.enterpriseQualification.toString();
      }
      this.$httpApi
        .post(url, params)
        .then((r) => {
          if (r.code == 200) {
            this.$message.success("保存成功");
            this.policyDataList = [];
            this.getCompanydetails(this.userBaseInfo.tyshxydm);
            this.getpx();
            this.detailVisible = false;
          } else {
            this.$message.error(r.msg);
          }
        })
        .catch((e) => {});
    },
    echartest() {
      let policySearchData = JSON.parse(
        sessionStorage.getItem("policySearchData")
      );

      // 基于准备好的dom，初始化echarts实例
      let money = this.$echarts.init(document.getElementById("money"));
      let project = this.$echarts.init(document.getElementById("project"));
      let lefttime = this.$echarts.init(document.getElementById("lefttime"));
      let deptAll = this.$echarts.init(document.getElementById("deptAll"));

      let proType = this.$echarts.init(document.getElementById("proType"));
      let finance = this.$echarts.init(document.getElementById("finance"));
      let total = this.$echarts.init(document.getElementById("total"));
      let technology = this.$echarts.init(
        document.getElementById("technology")
      );
      let high = this.$echarts.init(document.getElementById("high"));
      let middle = this.$echarts.init(document.getElementById("middle"));

      // 预期可申报资助
      let ksbzzData = this.ksbzzData;
      let moneyOption = getApplyFunding(ksbzzData);
      // 政策项目匹配度情况
      let xmppdData = this.xmppdData;
      let projectOption = getProMatching(xmppdData);
      // 政策项目申报截至剩余时间
      let limitTimeData = this.limitTimeData;
      let lefttimeOption = getProLeftTime(limitTimeData);
      // 受理部门分布
      let deptName = [];
      let alldeptnum = [];
      let alldeptmoney = [];
      let fivedeptnum = [];
      let fivedeptmoney = [];
      let fourdeptnum = [];
      let fourdeptmoney = [];
      let threedeptnum = [];
      let threedeptmoney = [];
      Object.keys(this.xmfbqkListALl.allDeptNum).forEach((keys) => {
        deptName.push(keys);
        alldeptnum.push(this.xmfbqkListALl.allDeptNum[keys]);
      });
      alldeptmoney = this.getrightData(
        deptName,
        this.xmfbqkListALl.allDeptMoney
      );
      fivedeptnum = this.getrightData(
        deptName,
        this.xmfbqkListALl.fiveStarDept
      );
      fourdeptnum = this.getrightData(
        deptName,
        this.xmfbqkListALl.fourStarDept
      );
      threedeptnum = this.getrightData(
        deptName,
        this.xmfbqkListALl.threeStarDept
      );
      fivedeptmoney = this.getrightData(
        deptName,
        this.xmfbqkListALl.fiveStartDeptMoney
      );
      fourdeptmoney = this.getrightData(
        deptName,
        this.xmfbqkListALl.fourStartDeptMoney
      );
      threedeptmoney = this.getrightData(
        deptName,
        this.xmfbqkListALl.threeStartDeptMoney
      );
      this.alldeptData = [
        deptName,
        alldeptnum,
        alldeptmoney,
        fivedeptnum,
        fivedeptmoney,
        fourdeptnum,
        fourdeptmoney,
        threedeptnum,
        threedeptmoney,
      ];
      // 项目类别分布
      //       allXmlbMoneyTotal: {三大改造: 232, 贷款贴息贴保: 0, 其他: 0}
      // allXmlbNum: {三大改造: 4, 贷款贴息贴保: 1, 其他: 1}
      // guojiaItem: {其他: 1}
      // guojiaMoney: 0
      // shengjiItem: {三大改造: 3, 贷款贴息贴保: 1}
      // shengjiMoney: 232
      // shijiItem: {}
      // shijiMoney:
      let allproName = [];
      let allpronum = [];
      let allpromoney = [];
      let gjpronum = [];
      let shengjipronum = [];
      let shijipronum = [];
      let gjpromoney = [];
      let shengjipromoney = [];
      let shijipromoney = [];
      Object.keys(this.xmlbflAll.allXmlbNum).forEach((keys) => {
        allproName.push(keys);
        allpronum.push(this.xmlbflAll.allXmlbNum[keys]);
      });
      allpromoney = this.getrightData(
        allproName,
        this.xmlbflAll.allXmlbMoneyTotal
      );
      gjpronum = this.getrightData(allproName, this.xmlbflAll.guojiaItem);
      gjpromoney = this.getrightData(allproName, this.xmlbflAll.guojiaMoney);
      shengjipronum = this.getrightData(allproName, this.xmlbflAll.shengjiItem);
      shengjipromoney = this.getrightData(
        allproName,
        this.xmlbflAll.shengjiMoney
      );
      shijipronum = this.getrightData(allproName, this.xmlbflAll.shijiItem);
      shijipromoney = this.getrightData(allproName, this.xmlbflAll.shijiMoney);
      this.allproData = [
        allproName,
        allpronum,
        allpromoney,
        gjpronum,
        gjpromoney,
        shengjipronum,
        shengjipromoney,
        shijipronum,
        shijipromoney,
      ];
      let deptOption = getDeptAll(this.alldeptData);
      let proTypeOption = getProTypeAll(this.allproData);

      let info = JSON.parse(JSON.stringify(this.gsData));

      // 这里从界面获取
      let zscqSum =
        info.zscq.zscqzs + info.zscq.zlzs + info.zscq.zcsbzs + info.zscq.rjzzzs;
      let jjzbList = policySearchData.jjzbList; //企业近三年经营情况分析
      let jjzbOne = jjzbList[0];
      let jjzbTwo = jjzbList[1];
      let jjzbThree = jjzbList[2];
      let finaceData = [
        [
          jjzbOne.zzc,
          jjzbOne.jlr,
          jjzbOne.yysr,
          jjzbOne.zyywsr,
          jjzbOne.zctr,
          jjzbOne.fzze,
          jjzbOne.nsze,
          jjzbOne.yftl,
        ],
        [
          jjzbTwo.zzc,
          jjzbTwo.jlr,
          jjzbTwo.yysr,
          jjzbTwo.zyywsr,
          jjzbTwo.zctr,
          jjzbTwo.fzze,
          jjzbTwo.nsze,
          jjzbTwo.yftl,
        ],
        [
          jjzbThree.zzc,
          jjzbThree.jlr,
          jjzbThree.yysr,
          jjzbThree.zyywsr,
          jjzbThree.zctr,
          jjzbThree.fzze,
          jjzbThree.nsze,
          jjzbThree.yftl,
        ],
      ];
      let finaceYear = ["2021年", "2020年", "2019年"];
      let financeOption = getFinanceThreeYear(finaceYear, finaceData);

      let zscq = policySearchData.zscq; //知识产权
      let rcxx = policySearchData.rcxx; //人才信息
      let zscqTotal =
        parseInt(zscq.rjzzzs) +
        parseInt(zscq.zcsbzs) +
        parseInt(zscq.zlzs) +
        parseInt(zscq.zscqzs);
      let rcxxTotal =
        parseInt(rcxx.gjzcrs) +
        parseInt(rcxx.kjrs) +
        parseInt(rcxx.qyzrs) +
        parseInt(rcxx.zjzcrs);

      let totalOption = getIntellectualProperty(
        "知识产权",
        "产权总数",
        [parseInt(zscq.zscqzs), zscqTotal],
        1
      );
      let highOption = getIntellectualProperty(
        "专利",
        "产权总数",
        [parseInt(zscq.zlzs), zscqTotal],
        2
      );
      let technologyOption = getIntellectualProperty(
        "职称",
        "人才总数",
        [parseInt(rcxx.gjzcrs) + parseInt(rcxx.zjzcrs), rcxxTotal],
        3
      );
      let middleOption = getIntellectualProperty(
        "科技",
        "人才总数",
        [parseInt(rcxx.kjrs), rcxxTotal],
        4
      );

      // 绘制图表
      money.setOption(moneyOption);
      project.setOption(projectOption);
      lefttime.setOption(lefttimeOption);
      deptAll.setOption(deptOption);

      proType.setOption(proTypeOption);
      finance.setOption(financeOption);
      // knowledge.setOption(knowledgeOption)
      total.setOption(totalOption);
      technology.setOption(technologyOption);
      high.setOption(highOption);
      middle.setOption(middleOption);
    },
    // 获取正确的数据格式
    getrightData(deptName, val) {
      let data = [];
      deptName.forEach((item, index) => {
        data.push(0);
        Object.keys(val).forEach((keys) => {
          if (item == keys) {
            data[index] = val[keys];
          }
        });
      });
      return data;
    },
    newresult(param) {
      let that = this;
      let url = "/dev-api/policy/evaluation/policyPushMatching";
      let params = param;
      params["pageSize"] = this.pagination2.pagesize;
      params["pageNum"] = this.pagination2.pagenum;
      that.$httpApi
        .post(url, params)
        .then((res) => {
          if (res.code == 200) {
            this.newpolicyDataList = res.data.passList;
            this.pagination2.total = res.data.allTotal;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    todetailpages(item) {
      let data = JSON.stringify(item);
      sessionStorage.setItem("policyDetailData", data);
      window.sessionStorage.setItem("flag", false);
      window.sessionStorage.setItem("status", false);
      let { href } = this.$router.resolve({
        name: "showPolicyDetail",
      });
      window.open(href, "_blank");
    },
    changechoose(val) {
      if(val==3){
        this.gettabelList();
      }
      this.choosetype = val;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/newStyle/css/idx.scss";
.globe {
  font-family: Microsoft YaHei;
}
.banner {
  padding-top: 1vh;
  height: 200px;
  width: 99.1vw;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  //  background-image: url("~@/assets/images/js_banner.png");sub_banner.png
  background-image: url("~@/assets/images/sub_banner.png");
  .stepCon {
    width: 900px;
    margin-left: calc(50% - 450px);
    margin-top: 60px;
    position: relative;
    .divider {
      width: 375px;
      height: 3px;
      background-color: #fff;
      border: 2px solid #fff;
    }
    .step {
      font-size: 18px;
      color: #fff;
      position: absolute;
      top: 60px;
    }
    .step1 {
      left: -30px;
    }
    .step2 {
      left: 395px;
    }
    .step3 {
      width: 150px;
      left: 800px;
    }
    .num {
      display: inline-block;
      width: 26px;
      height: 26px;
      border-radius: 50%;
      border: 1px solid #fff;
      text-align: center;
      line-height: 26px;
      color: #fff;
      margin-right: 6px;
    }
    .curStep {
      color: #fff71a;
      .num {
        color: #fff71a;
        border: 1px solid #fff71a;
      }
    }
  }
}
.gs-bigbanner {
  width: 100vw;
}
.gs-banner {
  background-color: #f9f9f9;
  width: 80vw;
  height: 24.9vh;
  margin: 0 auto;
  margin-top: 2vh;
}

.gs-name {
  padding-top: 2.2vh;
  padding-left: 1.2vw;
  color: rgba(0, 0, 0, 1);
  font-weight: 700;
  font-family: Microsoft YaHei;
  font-size: 1.5rem;
  float: left;
  height: 8vh;
}

.gs-name-tag {
  font-size: 1rem;
  border-radius: 20px;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  width: 90px;
  text-align: center;
  // border: 1px solid #dd0000;
  background-color: #38a435;
  color: #fff;
}

.gs-use-time {
  padding-top: 3.2vh;
  padding-right: 1.2vw;
  float: right;
  font-size: 0.875rem;
  color: rgba(102, 102, 102, 1);
}

.gs-content {
  clear: both;
  margin: 0 auto;
  height: 15vh;
  width: 61vw;
}

.gt-name {
  padding-left: 1.2vw;
  font-weight: 700;
  font-size: 1.25rem;
  padding-top: 2.2vh;
  color: rgba(0, 0, 0, 1);
}

.gt-one {
  font-size: 1rem;
  margin-left: 1.2vw;
  margin-top: 5vh;
  width: 63vw;
}

.gt-one-one {
  // text-align: right;
  //position:left;
  // margin-bottom: 0.6vh;
  // margin-left: 1%;
  width: 62vw;
}

.gt-three {
  padding-top: 7vh;
  margin-left: 41vw;
}

.gt-btn {
  //width: 9.4rem;
  //background-color: rgba(221, 0, 0, 1);
  //background-color: #1472FF;
  //width: 158px;
  //height: 40px;
  //color: rgba(255, 255, 255, 1);
  //color: #fff;
  //font-size: 1rem;
  //border-radius: 20px;
  height: 40px;
  line-height: 40px;
  background: #1472ff;
  color: #fff !important;
  font-size: 16px;
  padding: 0 18px;
  border-radius: 20px;
  text-align: center;
  border: 0;
  cursor: pointer;
  // float: left;
}

.re-top {
  padding-top: 1.5rem;
  height: 8.125rem;
}

.re-name {
  cursor: pointer;
  color: #333;
  font-size: 1.375rem;
  font-weight: 700;
  width: 63vw;
  // margin-left: -120px;
}
.tabActive {
  // color: rgba(223, 29, 9, 1);
  color: #1472ff;
}
.re-info {
  font-size: 0.875rem;
  margin-top: 1vh;
  text-align: right;
  // margin-right: -8vw;
}

.re-list {
  padding: 0vh 1vw 2vh 1vw;
}

.re-list-name {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-size: 1.125rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 1);
}

.re-tag {
  display: inline-block;
  border-radius: 17px;
  border: 1px solid #1472FF;
// width: 6.25rem;
  height: 34px;
  line-height: 32px;
  text-align: center;
  color: #1472FF;
  font-size: 1rem;
  margin: 0.3125rem;
  padding: 0 20px;
// overflow: hidden;
// white-space: nowrap;
// text-overflow: ellipsis;
}
.re-list-info {
  float: left;
  margin-right: 2vw;
  margin-top: 0.5vh;
  font-size: 0.875rem;
  color: rgba(153, 153, 153, 1);
}

.rt-money {
  font-weight: 700;
  font-size: 1.25rem;
  // color: rgba(221, 0, 0, 1);
  line-height: 30px;
  text-align: center;
}

.rt-btn {
  height: 40px;
  line-height: 40px;
  background: #1472FF;
  color: #fff !important;
  font-size: 16px;
  padding: 0 18px;
  border-radius: 20px;
  text-align:
    center; border: 0;
  cursor: pointer;
}
.re-start {
  float: right;
  margin-top: 0.2vh;
}

/** 分页组件  **/
.pg-css {
  text-align: center;
  margin-top: 3vh;
}
::v-deep .number {
  width: 1.85vw;
  height: 3.8vh;
  line-height: 3.8vh;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #1472ff;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #1472ff;
}

::v-deep .btn-prev {
  width: 1.85vw;
  height: 3.8vh;
  line-height: 3.8vh;
}

::v-deep .btn-next {
  width: 1.85vw;
  height: 3.8vh;
  line-height: 3.8vh;
}
::v-deep .el-pagination .el-select .el-input .el-input__inner {
  height: 3.8vh;
}
::v-deep .el-pagination__editor.el-input .el-input__inner {
  height: 3.8vh;
}
::v-deep .el-pagination__total {
  font-size: 1rem;
  line-height: 3.8vh !important;
}
/**  弹框  **/
::v-deep .el-dialog__header {
  border-bottom: 1px solid rgba(232, 232, 232, 1);
}
::v-deep .el-dialog__body {
  padding-top: 1vh;
}
::v-deep .el-divider--horizontal {
  // margin-left: -130px;
  // width: 127%;
  margin: 0;
}
.dt-top {
  font-family: Microsoft YaHei;
  font-weight: 700;
  font-size: 1.25rem;
  color: rgba(0, 0, 0, 1);
}
.dt-title-icon {
  height: 2.5vh;
  // border: 4px solid rgba(221, 0, 0, 1);
  border: 4px solid #1472ff;
}
.dt-title {
  margin-left: 1vw;
  font-family: Microsoft YaHei;
  font-weight: 600;
  color: rgba(0, 0, 0, 1);
  font-size: 1.125rem;
}
.dt-collapse {
  border: none;
}
::v-deep .el-collapse-item__wrap {
  border: none;
}
::v-deep .el-collapse-item__header {
  border: none;
}
.dt-div-btn {
  text-align: center;
  margin-top: 2vh;
}
.dt-confirm {
  //border-color: rgba(221, 0, 0, 1);

  // background-color: rgba(221, 0, 0, 1); #1472FF
  font-size: 1.125rem;
  border-color: #1472ff;
  background-color: #1472ff;
  color: rgba(255, 255, 255, 1);
  padding: 10px 20px;
}
::v-deep .el-button {
  border-radius: 20px;
}
.div-center {
  align-content: center;
  margin: 0 auto;
  text-align: center;
}

.round {
  width: 100%;
  height: 250px;
}
.round-rc {
  width: 60%;
  height: 150px;
}
.icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 2px solid #fff;
  background-color: #448dfc;
  background-position: center center;
  background-repeat: no-repeat;
}
.jbxx .el-row {
  margin: 16px auto;
}
</style>
